$(document).ready(function(){

	var $toggle		= $('a#menu-toggle'),
		$nav		= $('nav#main-nav', $header),
		$ul			= $('ul.main', $nav),
		$weather	= $('div#weather_menu', $nav);

	// Hamburger menu toggle handling
	$toggle.on('click', function(e){
		e.preventDefault();

		if ($ul.hasClass('open')) {
			// Toggle the menu closed.
			$.combine($toggle, $nav, $ul).removeClass('open');

			// Reset all sub-menu states.
			$('.open', $nav).removeClass('open');
			$('li.menu-back', $nav).remove();
		} else {
			// Toggle the menu open.
			$.combine($toggle, $nav, $ul).addClass('open');
		}
	});

	// Mobile sub-menu open handling
	$header.on('click', 'nav#main-nav.open li.has-children > a', function(e){
		var $a			= $(this),
			$li 		= $a.parent('li'),
			$submenu	= $li.find('> .sub-menu > .wrap > ul'),
			$container	= $li.closest('.container');

		// Only implement submenu if such exists.
		if ($submenu.length <= 0) {
			return;
		}

		e.preventDefault();

		// Open the relavent sub-menu.
		$.combine($container, $li).addClass('open');

		// Add a back button to close the sub-menu.
		$('<a href="#">Back</a>')
			.click(function(){
				$.combine($container, $li).removeClass('open');
				$(this).remove();
			})
			.appendTo($submenu)
			.wrap('<li class="menu-back"></li>');

	});




	// Weather menu widget
	$weather.on('click', 'a', function(e){
		e.preventDefault();

		var	$a			= $(this),
			$submenu	= $('.sub-menu', $weather);

		$weather.toggleClass('open');
	});

	// Ensure weather menu is closed when main nav submenus are triggered.
	$nav.on('mouseover', 'ul.main > li', function(e){
		$weather.removeClass('open');
	});

});

